export const BUSINESS_TIME_ZONE = "Europe/Moscow";

const DAY_RE = /^(\d{4})-(\d{2})-(\d{2})$/;

export function businessToday(now: Date = new Date()): string {
  return new Intl.DateTimeFormat("en-CA", {
    timeZone: BUSINESS_TIME_ZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(now);
}

export function latestClosedBusinessDay(now: Date = new Date()): string {
  return addCalendarDays(businessToday(now), -1);
}

export function isCalendarDay(value: string): boolean {
  const match = DAY_RE.exec(value);
  if (!match) return false;
  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  if (month < 1 || month > 12 || day < 1) return false;
  const date = new Date(Date.UTC(year, month - 1, day));
  return (
    date.getUTCFullYear() === year &&
    date.getUTCMonth() === month - 1 &&
    date.getUTCDate() === day
  );
}

export function addCalendarDays(day: string, delta: number): string {
  const match = DAY_RE.exec(day);
  if (!match || !isCalendarDay(day)) {
    throw new Error(`Некорректная дата: ${day}`);
  }
  const date = new Date(
    Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3])),
  );
  date.setUTCDate(date.getUTCDate() + delta);
  return formatUtcDay(date);
}

export function addCalendarMonths(day: string, delta: number): string {
  const match = DAY_RE.exec(day);
  if (!match || !isCalendarDay(day)) {
    throw new Error(`Некорректная дата: ${day}`);
  }
  const year = Number(match[1]);
  const monthIndex = Number(match[2]) - 1;
  const dayOfMonth = Number(match[3]);
  const shifted = new Date(Date.UTC(year, monthIndex + delta, 1));
  const lastDay = new Date(
    Date.UTC(shifted.getUTCFullYear(), shifted.getUTCMonth() + 1, 0),
  ).getUTCDate();
  return formatUtcDay(
    new Date(
      Date.UTC(
        shifted.getUTCFullYear(),
        shifted.getUTCMonth(),
        Math.min(dayOfMonth, lastDay),
      ),
    ),
  );
}

function formatUtcDay(date: Date): string {
  const year = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day = String(date.getUTCDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}
